import { generatedAPI } from '@grafana/api-clients/rtkq/notifications.alerting/v0alpha1';

export const timeIntervalsApi = generatedAPI;
